const safeName = (s) => (s || "document").replace(/[^\w\- ]+/g, "").trim() || "document";

async function save(element, filename) {
  const { pdf } = await import("@react-pdf/renderer");
  const blob = await pdf(element).toBlob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${safeName(filename)}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}

export async function exportPdf(type, doc) {
  const { ResumePdf, LetterPdf } = await import("@/lib/pdfDocs");
  const Comp = type === "resume" ? ResumePdf : LetterPdf;
  await save(<Comp template={doc.template} data={doc.data} title={doc.title} accent={doc.accent} />, doc.title);
}

export async function downloadInvoice(inv) {
  const { InvoicePdf } = await import("@/lib/pdfDocs");
  await save(<InvoicePdf inv={inv} />, `Pitchpaper invoice ${inv.number}`);
}
